/**
 * Polls a predicate until truthy or timeout. Returns true if the predicate
 * resolved truthy within the timeout, false otherwise.
 *
 * Used by share intents to wait for app readiness (forge service ready,
 * facility loaded, etc.) before mutating viewer state during deep-link
 * arrival. Tolerates predicate exceptions — those are treated as "not yet
 * ready" and retried.
 *
 * @param {() => boolean | Promise<boolean>} predicate
 * @param {{ timeout?: number, interval?: number }} [options]
 * @returns {Promise<boolean>}
 */
export async function waitFor(predicate, { timeout = 10000, interval = 100 } = {}) {
  const start = Date.now();
  while (Date.now() - start < timeout) {
    try {
      if (await predicate()) return true;
    } catch {
      // Predicate threw — treat as falsy and retry until timeout.
    }
    await new Promise((r) => setTimeout(r, interval));
  }
  return false;
}
